import React, { useEffect, useState } from "react";
import { SiLeetcode } from "react-icons/si";
import { motion } from "framer-motion";
import ReactLoading from "react-loading";

function LeetCode() {
  const [data, setData] = useState({});
  const [badgeData, setBadgeData] = useState({});
  const [loading, setLoading] = useState(true);
  let rank = data.ranking || 12000;
  let badges = badgeData.badgesCount || 41;
  let Reputation = data.reputation || 386;
  let totalSolved = data.totalSolved || 1000;
  let totalQuestions = data.totalQuestions || 3000;
  let totalSolvedPercent = ((totalSolved / totalQuestions) * 100).toFixed(1);
  let easySolved = data.easySolved || 300;
  let totalEasy = data.totalEasy || 1000;
  let easyBeats = 84;
  let easySolvedPercnt = ((easySolved / totalEasy) * 100).toFixed(1);
  let mediumSolved = data.mediumSolved || 350;
  let totalMedium = data.totalMedium || 1000;
  let mediumBeats = 92;
  let mediumSolvedPercnt = ((mediumSolved / totalMedium) * 100).toFixed(1);
  let hardSolved = data.hardSolved || 250;
  let totalHard = data.totalHard || 1000;
  let hardBeats = 87;
  let hardSolvedPercnt = ((hardSolved / totalHard) * 100).toFixed(1);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetch(
        "https://leetcode-api-faisalshohag.vercel.app/pranavmappoli"
      )
        .then((res) => res.json())
        .catch((e) => console.error(e));

      const badgeData = await fetch(
        "https://leetcode-api-faisalshohag.vercel.app/badges"
      )
        .then((res) => res.json())
        .catch((e) => console.error(e));
      if (!data || !badgeData) {
        setLoading(false);
        return;
      }
      setBadgeData(badgeData);
      setData(data);
      setLoading(false);
    };
    fetchData();
  }, []);
  console.log(totalSolved, totalSolvedPercent);
  return (
    <>
      {loading && (
        <div className="flex justify-center items-center min-h-[17.5rem] h-full w-full">
          <ReactLoading
            type={"bubbles"}
            color={"hsl(250, 69%, 61%)"}
            height={"25%"}
            width={"25%"}
          />
        </div>
      )}
      {!loading && (
        <>
          {/* title */}
          <div className="flex gap-2 items-center pb-4 justify-left section__contentTitle">
            LeetCode
            <span className="text-xl font-bold text-yellow-500">
              <SiLeetcode></SiLeetcode>
            </span>
          </div>
          {/* main flex */}
          <div className="flex gap-2 justify-center items-center md:gap-4">
            {/* round progress */}
            <motion.div
              initial={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${0}deg,
            hsla(250, 69%, 61%, 0.40) ${0}deg
            )`,
              }}
              animate={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${totalSolvedPercent * 3.6}deg,
            hsla(250, 69%, 61%, 0.40) ${totalSolvedPercent * 3.6}deg
            )`,
              }}
              transition={{ duration: 1.5, ease: "easeIn" }}
              className="w-[40%]  aspect-square rounded-full relative shadow-sm"
            >
              <div className="flex items-center flex-col  justify-center w-[93%]  about__content  bg-containerColor dark:bg-darkContainerColor aspect-square rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <span className="text-xl font-semibold">{totalSolved}</span>
                <div className="h-[1px] w-[80%] bg-leetcodeBorderColor my-1"></div>
                <span className="opacity-80">{totalQuestions}</span>
              </div>
            </motion.div>
            {/* bars */}
            <div className="flex flex-col gap-4 justify-center items-center w-full font-normal md:gap-2 lg:gap-3">
              {/* bar 1 */}
              <div className="flex flex-col gap-1 w-full about__content">
                {/* heading of bar */}
                <div className="flex justify-between items-end pb-2">
                  <span>Easy</span>
                  <span>
                    <span className="font-medium text-titleColor dark:text-darkTitleColor sm:text-lg md:text-md lg:text-lg">
                      {easySolved}
                    </span>
                    /{totalEasy}
                  </span>
                  <span>Beats: {easyBeats}%</span>
                </div>
                <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${easySolvedPercnt}%` }}
                    className="relative h-1 bg-blue-500 rounded-lg"
                    transition={{ duration: 1.5, ease: "easeIn" }}
                  >
                    <span className="text-[0.5rem] md:text-[0.25rem] lg:text-[0.5rem]  text-white absolute right-0 translate-x-full -translate-y-1/2 w-6 h-6 md:w-4 md:h-4 lg:w-6 lg:h-6    bg-blue-400 rounded-full flex justify-center items-center">
                      {easySolvedPercnt}%
                    </span>
                  </motion.div>
                </div>
              </div>

              {/* bar 2 medium */}
              <div className="flex flex-col gap-1 w-full about__content">
                {/* heading of bar */}
                <div className="flex justify-between items-end pb-2">
                  <span>Medium</span>
                  <span>
                    <span className="font-medium text-titleColor dark:text-darkTitleColor sm:text-lg md:text-md lg:text-lg">
                      {mediumSolved}
                    </span>
                    /{totalMedium}
                  </span>
                  <span>Beats: {mediumBeats}%</span>
                </div>
                <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${mediumSolvedPercnt}%` }}
                    className="relative h-1 bg-green-500 rounded-lg"
                    transition={{ duration: 1.5, ease: "easeIn" }}
                  >
                    <span className="text-[0.5rem] md:text-[0.25rem] lg:text-[0.5rem]  text-white absolute right-0 translate-x-full -translate-y-1/2 w-6 h-6 md:w-4 md:h-4 lg:w-6 lg:h-6   bg-green-400 rounded-full flex justify-center items-center">
                      {mediumSolvedPercnt}%
                    </span>
                  </motion.div>
                </div>
              </div>

              {/* bar 3 hard */}
              <div className="flex flex-col gap-1 w-full about__content">
                {/* heading of bar */}
                <div className="flex justify-between items-end pb-2">
                  <span>Hard</span>
                  <span>
                    <span className="font-medium text-titleColor dark:text-darkTitleColor sm:text-lg md:text-md lg:text-lg">
                      {hardSolved}
                    </span>
                    /{totalHard}
                  </span>
                  <span>Beats: {hardBeats}%</span>
                </div>
                <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${hardSolvedPercnt}%` }}
                    className="relative h-1 bg-red-500 rounded-lg"
                    transition={{ duration: 1.5, ease: "easeIn" }}
                  >
                    <span className="text-[0.5rem] md:text-[0.25rem] lg:text-[0.5rem]  text-white absolute right-0 translate-x-full -translate-y-1/2 w-6 h-6 md:w-4 md:h-4 lg:w-6 lg:h-6   bg-red-400 rounded-full flex justify-center items-center">
                      {hardSolvedPercnt}%
                    </span>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
          {/* bottom flex */}
          <div className="flex justify-between p-2 pt-8 container__content about__content">
            <div className="flex flex-col gap-1 justify-center items-center font-medium">
              <span>Rank</span>
              <span>{rank}</span>
            </div>
            <div className="w-1 opacity-20 bg-leetcodeBorderColor"></div>
            <div className="flex flex-col gap-1 justify-center items-center font-medium">
              <span>Badges</span>
              <span>{badges}</span>
            </div>
            <div className="w-1 opacity-20 bg-leetcodeBorderColor"></div>
            <div className="flex flex-col gap-1 justify-center items-center font-medium">
              <span>Reputation</span>
              <span>{Reputation}</span>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default LeetCode;
